import React from "react";

import AuthUserContext from "../firebase/AuthUserContext";
import { auth } from "../firebase";

import FlatButton from "./FlatButton";

class ProfilePopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { show: false };

    this.showPopup = this.showPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  componentWillReceiveProps(props, state) {
    if (props.show === true && this.state.show === false) {
      this.showPopup();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.closePopup);
  }

  showPopup() {
    this.setState({ show: true }, () => {
      document.addEventListener("click", this.closePopup);
    });
  }

  closePopup() {
    this.props.onClose();
    this.setState({ show: false }, () => {
      document.removeEventListener("click", this.closePopup);
    });
  }

  onBtnSignOut() {
    const { onSignOut } = this.props;
    if (onSignOut) onSignOut();
    auth.doSignOut();
  }

  render() {
    const { profile, avatar, landingPageStyle } = this.props;
    const hide = "ProfilePopup" + (this.state.show ? "" : " PopupHide");

    return (
      <AuthUserContext.Consumer>
        {authUser => (
          <div
            className={hide}
            style={
              landingPageStyle
                ? { zIndex: 101, right: -9, top: 50, position: "absolute" }
                : {}
            }
          >
            <div
              id="ProfileInfoStack"
              onClick={() => this.props.history.push("/profile")}
            >
              <img alt="Profile" className="ProfilePicture" src={avatar} />
              <p>{profile.first + " " + profile.last}</p>
            </div>
            <div id="Divider" />
            <div id="SideInfoStack">
              <p>{authUser.email}</p>
              <FlatButton
                label="Abmelden"
                onClick={() => this.onBtnSignOut()}
              />
            </div>
            <div id="Arrow" />
          </div>
        )}
      </AuthUserContext.Consumer>
    );
  }
}

export default ProfilePopup;



// WEBPACK FOOTER //
// ./src/components/ProfilePopup.js